import { Seo } from "../components/Seo";
import { hasCompanyDetails, hasText, site } from "../config/site";

export function AboutPage() {
  return (
    <main id="main" className="page">
      <Seo
        title="About"
        description="Beautiful Jewellery. Jewellery for everyday moments."
        path="/about"
      />
      <p className="kicker">About</p>
      <h1>{site.brandName}</h1>
      <p className="lede">Jewellery for everyday moments.</p>
      <p>
        A collection of rings, necklaces, earrings and bracelets is on its way.
        Pieces to wear through the day, and into quieter evenings.
      </p>
      <p className="quiet-note">Shopping is not available yet.</p>
      {hasCompanyDetails() ? (
        <section className="section">
          <h2>Company</h2>
          <dl className="detail-list">
            {hasText(site.company.registeredName) ? (
              <div>
                <dt>Registered company name</dt>
                <dd>{site.company.registeredName}</dd>
              </div>
            ) : null}
            {hasText(site.company.companyNumber) ? (
              <div>
                <dt>Company number</dt>
                <dd>{site.company.companyNumber}</dd>
              </div>
            ) : null}
            {hasText(site.company.registeredAddress) ? (
              <div>
                <dt>Registered address</dt>
                <dd>{site.company.registeredAddress}</dd>
              </div>
            ) : null}
          </dl>
        </section>
      ) : null}
    </main>
  );
}
